import { createContext, useContext } from "react";
const OfferRenderContext = createContext(null);
export function useOfferRenderContext() {
    const ctx = useContext(OfferRenderContext);
    if (!ctx) {
        return {};
    }
    return ctx;
}
export { OfferRenderContext };
